import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";

import TableComponent from "../components/TableComponent";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

function Center_list() {


    const [center_list, setCenter_list] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;
        axios.get(`${API_URL}/get_center_list`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then((res) => {
                setCenter_list(res.data.center_list || []);
                console.log("Center List:", res.data.center_list);
            })
            .catch((err) => {
                console.error("Center list error:", err);
            });
    }, []);



    const columns = [
        { key: "index", label: "Sr.no", format: (_, __, index) => index + 1 },
        { key: "center_name", label: "Center Name" },
        { key: "center_code", label: "Center Code" },
       
    ];



    return (
        <Container className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Center List</h3>
            </div>

            <TableComponent columns={columns} data={center_list} rowsPerPage={10} maxHeight={400} />
        </Container>
    );

}

export default Center_list;